// @flow

import { USER_TIMEZONE_ZD_TAG_PREFIX } from 'app/get-help/constants';

export const stringToZDTag = (str: string) => {
  return `${str.toLowerCase().replace(/ /g, '-').replace(/_/g, '-')}`;
};

export const getBrowserTimezoneZDTag = () => {
  let tz: string = 'not-available';
  try {
    tz = Intl.DateTimeFormat().resolvedOptions().timeZone || tz;
  } catch (e) {
    // Do nothing, we'll just use the default value
  }
  return stringToZDTag(`${USER_TIMEZONE_ZD_TAG_PREFIX}${tz}`);
};
